import { BookOpen } from "lucide-react";
import { LOGO_CONFIG } from "../config/logo";

const Logo = ({ className = "", textClassName = "" }) => {
  const {
    siteName,
    useLogo,
    logoPath,
    logoIconPath,
    showIcon,
    showText,
    logoHeight,
    iconSize,
    textSize,
    fontFamily
  } = LOGO_CONFIG;

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Site Name Text FIRST */}
      {showText && (
        <span 
          className={`${textSize} ${fontFamily} ${textClassName}`} 
          style={{ fontFamily: 'Fraunces, serif' }}
        >
          {siteName}
        </span>
      )}
      
      {/* Logo Image or Icon AFTER */}
      {useLogo ? (
        <img 
          src={logoPath} 
          alt={siteName} 
          className={logoHeight}
        />
      ) : showIcon && (
        <BookOpen className={`${iconSize} text-slate-900`} />
      )}
    </div>
  );
};

export default Logo;

// Layout: "The Archive" [Logo]
